import {React, useState} from "react";
import { Outlet} from "react-router-dom"
import QueryNavLink from "./Custom-Behavior";
import TotheTop from "./BacktoTop";
import {FaSortAlphaUp,FaSortAlphaDownAlt} from "react-icons/fa"


const AllCountries = ({data}) => {
  const [state, setState] = useState(data)
  const [inputValue, setInputValue] = useState()


const numberofCountry = () => {
  const score = state.map((data) => data)
  return score.length
}

  return (
    <section>
      <nav>
        <div className="TwoLink">
        <div className="max-w-[90%] mx-auto">
        <input 
        type="text"
        value={inputValue}
        placeholder="Search countries by name, capital, languages"
        onChange={(event) => {
           let filter = event.target.value ;
          if (filter) { 
            const myData = data.filter((data) => {
              let result = data.name.toLowerCase().includes(filter?.toLowerCase().trim()) || 
              data.capital.toLowerCase().includes(filter?.toLowerCase().trim()) || 
              data.languages.map((int) => {
                return int.toLowerCase()
              })[0].startsWith(filter?.toLowerCase().trim()) || 
              data.languages.map((int) => {
                return int.toLowerCase()
              }).includes(filter?.toLowerCase().trim());
              return result
            })
            setState(myData)
          } else {
            setState(data)
          } 
        }}
        style={{textIndent: 0,}}
        /> 
        </div>
       

         
        <div className="text-center">
          <div 
          onClick={() => setState(state === data ? [...data].reverse():data)}
          className="neon-button"
          >Name <span className="ml-2 op">{state === data? <FaSortAlphaUp />: <FaSortAlphaDownAlt />}</span></div>
        </div>
        <p className="text-gray-400">{numberofCountry() === 1 ? "Total Country": "Total Countries" }: {numberofCountry()}</p>
        </div>
        <div className="max-w-[98%] mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 ">
        {state.map((Datas) => ( 
          <div className="m-4 max-w-[200px] bg-slate-300/25 p-4 rounded-xl hover:scale-110 focus-within:scale-110 shadow-md shadow-slate-50/50"
          key={Datas.name}
          >
          <QueryNavLink to={`/countries/${Datas.population}`}
          onClick={()=>{
            setInputValue(() => "")
            setState(() => data)
          }}
           style={({isActive}) => {
            return {
             color: isActive ? "yellow" : "",
             textDecoration: "none"
            }
          }}>
            <div className="backdrop-blur-3xl focus-within:outline-0 focus-within:border-0">
              <div>
                <img src={Datas.flag} alt="countryflage"  className="w-full h-[100px] rounded-md focus-within:outline-0"/>
              </div>
              <div>
                <h1 className="text-center text-white hover:text-yellow-400 uppercase text-md tracking-widest">{Datas.name}</h1>
              </div>
            </div>
          </QueryNavLink>
          </div>
        ))}
          </div>
      </nav>
      <div className="toTophide">
        <TotheTop />
      </div>
      <Outlet />
    </section>
  )
}


export default AllCountries